import { Base_Url } from "../../BaseURL/BaseUrl";
import {
    getListWithAuthenticated,
    postApiWithAuthenticated,
} from "../ApiMethods/ApiMethod";

const notificationURL = `${Base_Url}/Notification`;

export const GetNotificationCount = async (UserKeyID) => {
    let url = `${notificationURL}/GetNotificationCount?UserKeyID=${UserKeyID}`;
    try {
        const res = await getListWithAuthenticated(url);
        return res;
    } catch (error) {
        console.error("Error adding appointment:", error);
        throw error;
    }
};
export const GetNotificationList = async (UserKeyID) => {
    let url = `${notificationURL}/GetNotificationList?UserKeyID=${UserKeyID}`;
    try {
        const res = await getListWithAuthenticated(url);
        return res;
    } catch (error) {
        console.error("Error adding appointment:", error);
        throw error;
    }
};
export const ViewNotification = async (NotificationKeyID) => {
    let url = `${notificationURL}/ViewNotification?NotificationKeyID=${NotificationKeyID}`;
    try {
        const res = await getListWithAuthenticated(url);
        return res;
    } catch (error) {
        console.error("Error adding appointment:", error);
        throw error;
    }
};
export const DeleteNotification = async (NotificationKeyID) => {
    let url = `${notificationURL}/DeleteNotification?NotificationKeyID=${NotificationKeyID}`;
    try {
        const res = await getListWithAuthenticated(url);
        return res;
    } catch (error) {
        console.error("Error adding appointment:", error);
        throw error;
    }
};